
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import CandidateCreateForm, {
  StructCandidateData
} from "@/lib/form/candidate/CandidateCreateForm";
import Candidate, {
  CandidateMCreateParams,
  CandidateMCreateParseParams,
  CandidateGet
} from "@/lib/model/exam/candidate";
import { paginationFn } from "@/lib/util/page";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import gateway from "@/lib/request/gateway";
import ModalTitle from "@/lib/model/exam/modal-title";
import Auth from "@/lib/common/auth";
import track from "@/lib/common/track";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import vuexStore from "@/store/vuex-store";
import { EnumSubmitStatus } from "@/lib/model/exambuilder/candidate-v3/candidate-v3-enum";

class ExamItem {
  id = 0;
  name = "";
  remark = "";
}

@Component({
  components: {
    ModalHeader
  }
})
export default class AddMoreCandidateModal extends Vue {
  name = "add-more-candidate";
  @Prop() private candidateMCreateParseParams!: CandidateMCreateParseParams;
  @Prop() candidateMCreateParams!: CandidateMCreateParams;
  @Prop() private examName!: string;
  @Prop() private examRemark!: string;
  @Prop() private isVisible!: boolean;
  @Prop() private examGetForm!: ExamGetForm;
  @Prop() private isShowAddMore!: boolean;
  @Prop() private examAll!: ExamItem[];
  @Prop() private paperId!: number;

  modalTitle: ModalTitle = new ModalTitle();
  currentData: any = [];
  tableHeaders: string[] = [""];
  isDisabled = true;
  canSelected = true;
  showSelectError = false;
  examFiltedAll: ExamItem[] = new Array<ExamItem>();
  selectedPaperId = 0;
  examSelected: any = "";
  showNoCandidateError = false;
  hasEmail = true;
  checkboxChoose: number[] = [];
  V = vuexStore;
  pageInfo = {
    page: 1,
    pageSize: 100
  };

  get tableData() {
    return paginationFn(
      this.currentData,
      this.pageInfo.page,
      this.pageInfo.pageSize
    );
  }

  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  get isWorker() {
    return this.V.isWorker;
  }

  get setTimeSendMessage() {
    return (
      !this.isWorker &&
      [92145, 80978, 91353].includes(Number(this.V.company.id))
    );
  }

  msgPickerOptions = {
    disabledDate: (date: any) => {
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
    }
  };

  // 公司使用限制相关数据
  limitInfo: any = {
    createLimit: {},
    noAnswerLimit: {}
  };
  // 当日当次上传候选人错误及重复条数大于阈值
  get isShowTable() {
    return this.errorList.length > this.limitInfo.createLimit.limit;
  }
  // 当日当次上传有效候选人+当日同一公司下累计已添加的候选人大于阈值
  get isShowTable2() {
    return (
      this.okList.length + this.limitInfo.createLimit.used >
      this.limitInfo.createLimit.limit
    );
  }
  // 单场面试中，未参与面试人数超过设定阈值
  get isShowTable3() {
    return (
      this.okList.length + this.limitInfo.noAnswerLimit.used >
      this.limitInfo.noAnswerLimit.limit
    );
  }

  get okList() {
    return this.currentData.filter((e: any) => e.isOk === true);
  }

  get errorList() {
    return this.currentData.filter((e: any) => e.isOk === false);
  }

  get uploadUrl() {
    // return _.trim(config.apiUrl) + "/aiExam/candidate/mCreate";
    return "/";
  }

  get token() {
    return Auth.token;
  }

  get warnInfo() {
    const info = {
      add: 0,
      other: 0,
      noSignReal: 0,
      hasSignReal: 0,
      hasSubmitReal: 0
    };

    this.currentData.forEach((item: any) => {
      if (item.isOk) {
        info.add++;
      } else {
        switch (item.submitStatus) {
          case EnumSubmitStatus.EnumSubmitStatusNotSignIn:
            info.noSignReal++;
            break;
          case EnumSubmitStatus.EnumSubmitStatusSignIn:
            info.hasSignReal++;
            break;
          case EnumSubmitStatus.EnumSubmitStatusFinish:
            this.checkboxChoose.includes(item.submitStatus);
            info.hasSubmitReal++;
            break;
          default:
            info.other++;
        }
      }
    });
    return info;
  }

  changeTimePicker(str: string) {
    // eldatepicker点击此刻没给抛出时间，只能自己搞一个了。。。
    const time = new Date(str).getTime();
    const now = Date.now();
    if (time + 1000 > now && time - 1000 < now) {
      // 误差在1秒之内认为点击了此刻按钮，清空
      this.candidateMCreateParams.sendMessageTime = "";
    }
  }

  @Watch("isVisible")
  onIsVisibleChange() {
    this.currentData = [];
  }

  @Watch("okList")
  onOkListChange() {
    if (this.okList.length > 0) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  @Emit("on-close-more")
  handleClose() {
    this.candidateMCreateParams.sendMessage = 1;
    console.log("on-close-more");
  }

  mounted() {
    this.modalTitle.title = "批量添加候选人";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = this.examName;

    console.log(
      "this.candidateMCreateParams.sendMessage : ",
      this.candidateMCreateParams.sendMessage
    );

    this.candidateMCreateParams.sendMessage = this.candidateMCreateParams
      .sendMessage
      ? 1
      : 0;

    if (this.paperId > 0) {
      // this.examSelected = this.paperId;
      this.examSelected = this.examName;
      this.canSelected = false;
      this.selectedPaperId = this.paperId;
      this.checkEmail();
    }
    if (this.examAll?.length) {
      this.examFiltedAll = this.examAll.filter((examRes: any) => {
        return examRes.id > 0;
      });
    }
  }
  checkEmail() {
    if (!this.selectedPaperId) return;
    Candidate.checkEmail({ examId: this.selectedPaperId }).then(res => {
      if (res.code === 0) {
        this.hasEmail = res.data.hasEmail;
        this.$forceUpdate();
        console.log(this.hasEmail);
      }
    });
  }

  examSelect(paperId: number) {
    this.selectedPaperId = paperId;
    this.showSelectError = false;
    this.checkEmail();
  }
  //批量创建候选人
  isCreating = false;
  importMCandidate() {
    if (this.selectedPaperId === 0) {
      this.showSelectError = true;
      return;
    }
    track("candidate_page_interact", {
      exam_id: this.candidateMCreateParams.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      operation_type: "按钮点击",
      operation_name: "导入",
      from_page: "打通的候选人列表页"
    });
    track("click_add_candidate", {
      exam_id: this.candidateMCreateParams.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      add_type: "批量添加",
      operation_type: "按钮点击",
      operation_name: "导入",
      click_from: "从左侧候选人菜单进入候选人列表页"
    });

    if (this.isShowTable || this.isShowTable2 || this.isShowTable3) {
      this.$message.error("已超过上限，无法添加候选人");
      return;
    }
    if (this.isCreating) return;
    this.isCreating = true;
    this.candidateMCreateParams.examId = String(this.selectedPaperId);
    if (this.candidateMCreateParams.sendMessage) {
      this.candidateMCreateParams.sendMessageType = this.candidateMCreateParams
        .sendMessageTime
        ? 2
        : 0;
    } else {
      this.candidateMCreateParams.sendMessageType = 1;
      this.candidateMCreateParams.sendMessageTime = "";
    }
    if (this.setWeb) {
      const needRepeatCreateNoSignIn = this.checkboxChoose.includes(0);
      const needRepeatCreateSignIn = this.checkboxChoose.includes(3);
      const needRepeatCreateSubmit = this.checkboxChoose.includes(2);
      const paramsV3 = {
        ...this.candidateMCreateParams,
        needRepeatCreateNoSignIn,
        needRepeatCreateSignIn,
        needRepeatCreateSubmit,
        parseItemList: this.currentData
      };
      Candidate.candidateMCreateV3(paramsV3)
        .then(res => {
          if (res.code === 0) {
            this.$message.success("导入成功");
            this.handleClose();
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.isCreating = false;
          }, 1000);
        });
    } else if (this.okList.length > 0) {
      this.candidateMCreateParams.candidateList = [];
      this.okList.forEach((item: any, index: number) => {
        const params = new StructCandidateData();
        params.showName = item.showName;
        params.phone = item.phone;
        params.paramList = item.paramList;
        params.tagList = item.tagList;
        if (this.hasEmail) {
          params.email = item.email;
        }
        this.candidateMCreateParams.candidateList.push(params);
      });
      Candidate.candidateMCreate(this.candidateMCreateParams)
        .then(res => {
          if (res.code === 0) {
            this.$message.success("导入成功");
            this.handleClose();
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.isCreating = false;
          }, 1000);
        });
    } else {
      this.$message.error("当前没有可添加的候选人");
    }
  }

  importMCancel() {
    this.handleClose();
  }

  downloadExel() {
    if (this.selectedPaperId === 0) {
      this.showSelectError = true;
      return;
    }
    this.examGetForm.examId = this.selectedPaperId;
    ExamList.examExportExel(this.examGetForm).then(res => {
      const dataUrl = res.data.ossUrl;
      const a = document.createElement("a");
      a.href = dataUrl;
      a.setAttribute("download", "批量添加候选人模板");
      a.click();
    });
  }

  checkPaperId() {
    if (this.selectedPaperId === 0) {
      this.showSelectError = true;
    }
  }

  regenResult(list: any[]) {
    this.pageInfo.page = 1;
    return list.map(item => {
      item.isOk = item.isOk ?? item.canCreate;
      item.errorMsg = item.errorMsg || item.message;
      return item;
    });
  }
  //解析上传模板
  beforeUpload(file: File) {
    let isExcel = false;
    const ext = file.name.toLowerCase().split(".");
    // || ext[ext.length - 1] == "xls"
    if (ext[ext.length - 1] == "xlsx") {
      isExcel = true;
    }
    if (!isExcel) {
      this.$message.error("上传文件只能是 xlsx 格式!");
      return;
    }

    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + postRes.dir;
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
            this.candidateMCreateParseParams.ossUrl = res.url;
            this.candidateMCreateParseParams.examId = this.selectedPaperId;
            this.candidateMCreateParseParams.needExport = 1;
            this.candidateMCreateParseParams.needSort = 1;
            console.log(this.candidateMCreateParseParams);
          })
          .then(() => {
            const api = this.setWeb
              ? Candidate.candidateMCreateParseV3
              : Candidate.candidateMCreateParse;
            api(this.candidateMCreateParseParams).then(res => {
              if (res.code === 0) {
                if (res.data.count === 0) {
                  this.$message.warning("上传文件内容为空");
                }
                this.limitInfo = res.data.limitInfo;
                this.currentData = this.regenResult(res.data.list);
                // this.currentData = [];
                // // 异常的在前排展示
                // res.data.list.forEach((item: any) =>
                //   this.currentData[["unshift", "push"][Number(item.isOk)]](item)
                // );
                this.tableHeaders = res.data.headers;
                this.errorListUrl = res.data.excelUrl;
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch((err: any) => {
            return isExcel;
          })
          .finally(() => {
            return isExcel;
          });
      }
    });
  }

  getInterviewStatus(status: number) {
    let statusText = "";
    switch (status) {
      case 0:
        statusText = "未登记";
        break;
      case 1:
        statusText = "答题中";
        break;
      case 2:
        statusText = "已交卷";
        break;
      case 3:
        statusText = "已登记";
        break;
    }
    return statusText;
  }

  errorListUrl = "";
  exportError() {
    window.open(this.errorListUrl);
  }

  uploadSuccess(e: any) {
    console.log("uploadSuccess e: ", e);
  }

  askAgain(row: any, e: any) {
    if (e?.target?.className === "unit") {
      //已经点过一次
      return;
    }
    e.target.className = "unit";
    e.target.innerText = "已邀请";
    //单个邀请重面
    const p = new CandidateRepeatCreateForm();
    p.sendMessage = 1;
    p.candidateId = row.candidateId;
    Candidate.candidateRepeatCreate(p).then(resp => {
      if (resp.code === 0) {
        this.$message.success("邀请成功");
      } else {
        this.$message.error(resp.message);
      }
    });
  }
  send(row: any, e: any) {
    if (e?.target?.className === "unit") {
      //已经点过一次
      return;
    }
    e.target.className = "unit";
    e.target.innerText = "已通知";

    const p = new CandidateGet();
    p.candidateId = row.candidateId;
    p.sendMessageType = p.sendMessageTime ? 2 : 0;
    Candidate.sendAsk(p).then(resp => {
      if (resp.code === 0) {
        this.$message.success("通知成功");
      } else {
        this.$message.error(resp.message);
      }
    });
  }
  addFalse(event: any) {
    event.currentTarget.addClass("g66");

    //todo
    event.currentTarget.classList.push("g66");
  }
}
